import type { RequestFn } from '../http';

/**
 * 'BLOCKED' = nicht versendet, weil die Mail unter Admin → Kundenportal → Mails
 * abgeschaltet ist. Steht bewusst im Log: Man muss nachsehen können, was NICHT lief.
 */
export type EmailLogStatus = 'SENT' | 'FAILED' | 'BLOCKED';

export interface EmailLogListItem {
  id: string;
  toEmail: string;
  subject: string;
  mailType: string | null;
  category: string | null;
  provider: string | null;
  status: EmailLogStatus;
  errorMessage: string | null;
  openCount: number;
  openedAt: string | null;
  lastOpenedAt: string | null;
  clickCount: number;
  firstClickedAt: string | null;
  createdAt: string;
}

export interface EmailLogLink {
  id: string;
  url: string;
  clickCount: number;
  firstClickedAt: string | null;
  lastClickedAt: string | null;
}

export interface EmailLogDetail extends EmailLogListItem {
  customerId: string | null;
  contactId: string | null;
  userId: string | null;
  lastClickedAt: string | null;
  metadata: unknown;
  links: EmailLogLink[];
}

export interface EmailLogsListParams {
  q?: string;
  status?: EmailLogStatus | '';
  category?: string;
  mailType?: string;
  opened?: 'true' | 'false' | '';
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export interface EmailLogsListResponse {
  data: EmailLogListItem[];
  pagination: { hasMore: boolean; nextCursor: string | null };
}

export interface EmailLogsStatsResponse {
  range: { from: string; to: string };
  totals: {
    sent: number;
    failed: number;
    opened: number;
    clicked: number;
    openRate: number;
    clickRate: number;
  };
  byMailType: Array<{ mailType: string; count: number }>;
  byCategory: Array<{ category: string; count: number }>;
  trend: Array<{ date: string; sent: number; opened: number; clicked: number }>;
}

export function createEmailLogsApi(request: RequestFn) {
  return {
    async listEmailLogs(params: EmailLogsListParams = {}) {
      const qs = new URLSearchParams();
      if (params.q) qs.set('q', params.q);
      if (params.status) qs.set('status', params.status);
      if (params.category) qs.set('category', params.category);
      if (params.mailType) qs.set('mailType', params.mailType);
      if (params.opened) qs.set('opened', params.opened);
      if (params.from) qs.set('from', params.from);
      if (params.to) qs.set('to', params.to);
      if (params.cursor) qs.set('cursor', params.cursor);
      if (params.limit) qs.set('limit', String(params.limit));
      const query = qs.toString();
      return request<EmailLogsListResponse>(`/admin/email-logs${query ? `?${query}` : ''}`);
    },

    async getEmailLogsStats(params: { from?: string; to?: string } = {}) {
      const qs = new URLSearchParams();
      if (params.from) qs.set('from', params.from);
      if (params.to) qs.set('to', params.to);
      const query = qs.toString();
      return request<EmailLogsStatsResponse>(`/admin/email-logs/stats${query ? `?${query}` : ''}`);
    },

    async getEmailLog(id: string) {
      return request<{ item: EmailLogDetail }>(`/admin/email-logs/${id}`);
    },
  };
}
